export const POLICY_REVIEW_ACTIVE_LABEL = "Policy Context Available";

export function isPolicyContextAvailable(
  policyContextAvailable?: boolean
): boolean {
  return policyContextAvailable === true;
}

export function invokePolicyContextClear(onClearPolicyContext?: () => void) {
  onClearPolicyContext?.();
}
